module.exports = __webpack_public_path__ + "img/1right-n-8a9993c3.png";